module.exports = __webpack_public_path__ + "img/notification.9ee07cf3.svg";